import React from 'react';

const RoleContext = React.createContext(null);

export default RoleContext;
